<template>
    <div class="coms-header">
        <!--        {{ city.name }}-->
        <div class="coms-flex">
            <div></div>
            <div @click="router.replace({name:'city_list'})">
                {{ city.name }}
                <el-icon>
                    <CaretBottom/>
                </el-icon>
            </div>
        </div>
    </div>
    <div class="banner">
        <img src="@/assets/image/banner.jpg" alt="">
    </div>

    <div class="contents">
        <div class="content-tabs">
            <h3>生活缴费</h3>
            <el-row :gutter="20">
                <el-col :span="8" v-for="life in lifeType" :key="life.type">
                    <div class="life-type" @click="routerUrl(true,'pay',{type:life.type})">
                        <img src="@/assets/image/fees.png" v-if="life.type==='fees'">
                        <img src="@/assets/image/gas.png" v-if="life.type==='gas'">
                        <img src="@/assets/image/water.png" v-if="life.type==='water'">
                        <div>
                            {{ life.name }}
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="content-tabs recharge-details">
            <h3>兑换须知</h3>
            <ul class="recharge-details-info">
                <li>1. 本产品为虚拟商品，一经兑换概不退还、转售、找零或拆分使用；</li>
                <li>2. 川航里程兑换商品不提供报销凭证；</li>
                <li>3. 本页面仅提供支付宝生活缴费红包兑换，兑换成功后，请在支付宝“生活缴费小程序”中使用；</li>
                <li>4. 支付宝“生活缴费小程序”每次缴费限使用1个红包，若兑换多个红包，需分次使用；</li>
                <li>5. 红包自成功兑换之日起60天有效，请在有效期内使用，过期自动失效；</li>
                <li>6. 如需帮助，请拨打服务热线：4000-360-195。</li>
            </ul>
        </div>
        <!--        {{ orderLst }}-->
        <div class="content-tabs" v-if="Object.keys(account).length">
            <div class="content-tabs-title">
                <h3>近期兑换</h3>
                <div class="more" @click="routerUrl(true,'order')">更多记录</div>
            </div>
            <order-components index :cust-id="account.cust_id"/>
        </div>
    </div>
    <service-components/>
</template>

<script setup>
import {computed, onMounted} from "vue";
import store from "@/store";
import {getCity, onWayFn, routerUrl} from "@/utils/func";
import {lifeType} from "@/utils/constant";
import router from "@/router";
import {useRoute} from "vue-router";
import OrderComponents from "@/components/OrderComponents.vue";
import ServiceComponents from "@/components/ServiceComponents.vue";

const city = computed(() => store.state.city)
const route = useRoute()
const account = computed(() => store.state.account)

onMounted(() => {
    store.commit("getCity")
    store.commit("getAccount")
    if (Object.keys(city.value).length < 1) {
        getCity()
    }
    const cust_id = route.query.customerId
    if (cust_id) {
        let query = route.query;
        let its = {};
        for (var i in query) {
            let val = query[i];
            if (/\?.+=.*/.test(val)) {
                let info = val.split("?");
                its[i] = info[0];
                let inf = info[1].split("=")
                its[inf[0]] = inf[1]
            } else {
                its[i] = val;
            }
        }
        onWayFn(its)
    }
})

</script>

<style lang="less" scoped>

.banner {
  width: 92%;
  margin: -110px auto 20px;
  border-radius: 8px;
  overflow: hidden;

  img {
    width: 100%;
  }
}

.life-type {
  margin-top: 15px;
  text-align: center;
  background: #F9F8F6;
  padding: 15px;
  box-sizing: border-box;
  border-radius: 8px;

  img {
    width: 45px;
    margin-bottom: 10px;
  }
}

.content-tabs {
  margin-bottom: 20px;

  .content-tabs-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    border-bottom: 1px solid #D4D4D4;
    padding-bottom: 10px;

    .more {
      color: #9D9D9D;
    }
  }

  &.recharge-details {
    line-height: 2;
    font-size: 14px;
  }
}
</style>
